module.exports = __webpack_public_path__ + "static/media/editIcon.71070450.svg";